import { useQuery } from "react-query";
import axiosClient from "./../config/axiosClient";

const useOfferUpdatesList = ({offer_id}) => {
  return useQuery(
    ["offer-updates-list", offer_id],
    () => {
      return axiosClient
        .get(`/issuer/offers/${offer_id}/offer_updates`)
    }
  );
}

const useOfferUpdate = ({offer_update_id}) => {
  return useQuery(
    ["offer-update", offer_update_id],
    () => {
      return axiosClient
        .get(`/issuer/offer_updates/${offer_update_id}`)
    },
    {
      enabled: offer_update_id !== null && offer_update_id !== undefined,
      initialData: {},
    }
  );
}

function createOfferUpdate({offer_id, values}) {
  return axiosClient.post(`/issuer/offers/${offer_id}/offer_updates`, values)
}

function updateOfferUpdate({offer_update_id, values}) {
  return axiosClient.put(`/issuer/offer_updates/${offer_update_id}`, values)
}

export {
  useOfferUpdatesList,
  useOfferUpdate,
  createOfferUpdate,
  updateOfferUpdate,
}
